import {
  DECREMENT_LOWNOTE,
  INCREMENT_LOWNOTE,

  DECREMENT_OCTAVE,
  INCREMENT_OCTAVE,

  SET_ZONE_SPLIT_POINT,
  SET_ZONE_CURVE,
  SET_ZONE_CHANNEL,

  SELECT_GAP_CAP,
  SET_GAP_CAPS,
  SET_GAP_CAPS_CURVE,
  SET_GAP_CAPS_CHANNEL,
  TOGGLE_GAP_CAPS,

  SELECT_BAR
} from './actionTypes'

export const changeLowNote = (direction = 0) => ({ type: (direction === -1) ? DECREMENT_LOWNOTE : INCREMENT_LOWNOTE })
export const changeOctave = (direction = 0) => ({ type: direction === -1 ? DECREMENT_OCTAVE : INCREMENT_OCTAVE })

export const setZoneSplitPoint = (zone, bar) => ({ type: SET_ZONE_SPLIT_POINT, zone: zone, bar: bar });
export const setZoneCurve = (zone, curve) => ({ type: SET_ZONE_CURVE, zone: zone, curve: curve });
export const setZoneChannel = (zone, channel) => ({ type: SET_ZONE_CHANNEL, zone: zone, channel: channel });

export const setGapCaps = (notes, index, note) => ({ type: SET_GAP_CAPS, notes: notes, index: index, note: note });
export const setGapCapsCurve = (curve) => ({ type: SET_GAP_CAPS_CURVE, curve: curve });
export const setGapCapsChannel = (channel) => ({ type: SET_GAP_CAPS_CHANNEL, channel: channel });
export const toggleGapCaps = (notes) => {
  return (dispatch) => {
    dispatch({ type: SELECT_BAR, bar: -1 })
    dispatch({ type: SELECT_GAP_CAP, cap: -1 })
    dispatch({ type: TOGGLE_GAP_CAPS, notes: notes })
  }
};
